import {showCopyableIdTooltip} from '@utils/eventDetailsHelper';

const stageSportName = (event) => {
    return event.st_event.stage
        ? event.st_event.stage?.stage_category?.parent?.sport?.name
        : event.st_event?.stage_category?.parent?.sport?.name;
};

export const stageSportId = (event) => {
    return event.st_event.stage
        ? event.st_event.stage?.stage_category?.parent?.sport?.id
        : event.st_event?.stage_category?.parent?.sport?.id;
};

export const stageSport = (event) => showCopyableIdTooltip(
    stageSportName(event),
    stageSportId(event),
    'Sport'
);
